import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  viewLiveButton: {
    id: 'course-authoring.course-unit.button.view-live',
    defaultMessage: 'Ver versión en vivo',
  },
  previewButton: {
    id: 'course-authoring.course-unit.button.preview',
    defaultMessage: 'Vista previa',
  },
});

export default messages;
